var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendPortal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "icon-stroke",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.583
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.167 10.233c0-.663-.393-1.263-1-1.528l-17.5-7.61a1.677 1.677 0 0 0-1.334 0l-17.5 7.61c-.607.265-1 .865-1 1.528v19.462c0 .673.405 1.28 1.025 1.538l18.309 7.629c.428.178.91.17 1.333-.022l16.69-7.59c.595-.27.977-.863.977-1.517v-19.5zM20.833 17.473L1.142 9.268M20.833 17.473l18.032-8.196M11.978 4.298l18.502 8.797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.833 21.56a.833.833 0 0 0-.5-.763L7 17.15a.833.833 0 0 0-1.167.765v6.513c0 .332.197.631.5.764l8.334 3.646a.833.833 0 0 0 1.166-.763V21.56zM20.833 39.043v-21.57"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPortal);
export default __webpack_public_path__ + "static/media/send-portal.edc8397809da9d219392c52d5ce2c901.svg";
export { ForwardRef as ReactComponent };